export default function formatDisplayValue({ airports, airportCode }) {
  const airport = airports[airportCode]
  let result = ''

  if (airport) {
    if (airport.name) {
      result = airport.name
    } else if (airport.stateCode !== '--' && airport.stateCode !== '' && airport.stateCode) {
      result = `${airport.cityName}, ${airport.stateCode}`
    } else {
      result = `${airport.cityName}, ${airport.isoCountryCode || airport.countryCode || airport.country}`
    }

    // Airport names returned by typeahead can include parenthisized airport code, so don't add twice
    const endsWithAirportCode = result.match(/\(\w+\)$/)

    if (!endsWithAirportCode) {
      result = `${result} (${airportCode})`
    }
  }

  return result
}
